import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import {
  ReferralDetailsPayload,
  ReferralSearchPayload,
} from "../../../models/Referral";
import {
  getReferralListByProviderId,
  getReferralSearchList,
} from "../../../actions/ReferralAction";
import AllPatientList from "../components/AllPatientList";
import { GetReferralListActionDispatchTypes } from "../../../constants/HomePage";

const mapStateToProps = ({
  referralSearchState,
}: ApplicationState) => ({
  referralSearchList: referralSearchState.response
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getReferralSearchList: (payload: ReferralSearchPayload) => {
      dispatch(getReferralSearchList(payload));
    },
    getReferralListByProviderId: (payload: ReferralDetailsPayload) => {
      dispatch(getReferralListByProviderId(payload));
    },
    resetReferralList: () => {
      dispatch({
        type: GetReferralListActionDispatchTypes.GET_REFERRAL_LIST_RESET,
      });
    },  
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AllPatientList);
